module.exports = __webpack_public_path__ + "img/hongpei.7f4dc553.png";